// src/...(same path)/ProfileMenu.jsx
import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withTranslation } from "react-i18next";
import avatar2 from '../../../assets/images/users/avatar-2.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../../../store/reducers/user';
import { request } from '../../../utils/request'; // adjust relative path if needed

const ProfileMenu = (props) => {
    const [menu, setMenu] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState(avatar2);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toggle = () => setMenu(prevState => !prevState);

    // Read user from localStorage
    let username = "Admin";
    let userId = null;
    try {
        const raw = localStorage.getItem("user");
        if (raw) {
            const userObj = JSON.parse(raw);
            if (userObj && userObj.name) username = userObj.name;
            if (userObj && (userObj._id || userObj.id)) userId = userObj._id || userObj.id;
        }
    } catch (err) {
        // ignore
    }

    useEffect(() => {
      // fetch signed url (only if we have a userId)
      let mounted = true;
      const fetchAvatar = async () => {
        if (!userId) return;
        try {
          // request: GET /api/v1/user/:id/avatar
          const data = await request('user', { method: 'get', params: `${userId}/avatar` });
          // data expected: { url, expiresAt }
          if (mounted && data && data.url) {
            setAvatarUrl(data.url);
          }
        } catch (err) {
          // keep default avatar on error
          console.error('Failed to fetch avatar signed URL', err);
        }
      };
      fetchAvatar();
      return () => { mounted = false; };
    }, [userId]);

    const handleLogout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("authUser");
        localStorage.removeItem("token");
        localStorage.removeItem("session_Id");
        sessionStorage.clear();
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        dispatch(setUser(null));
        navigate("/");
    };

    return (
        <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block user-dropdown">
            <DropdownToggle tag="button" className="btn header-item waves-effect" id="page-header-user-dropdown">
                <img className="rounded-circle header-profile-user me-1" src={avatarUrl} alt="Header Avatar" style={{ width: 36, height: 36, objectFit: 'cover' }} />
                
                {/* Username hidden as requested — keeping the original element commented out so you can restore easily */}
                {/*
                <span className="d-none d-xl-inline-block ms-1 text-transform" style={{ color: 'white' }}>{username}</span>
                <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block" style={{ color: 'white' }}></i>
                */}
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
                <DropdownItem tag={Link} to="/profile">
                    <i className="ri-user-line align-middle me-1"></i> {props.t('Profile')}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem className="text-danger" onClick={handleLogout}>
                    <i className="ri-shut-down-line align-middle me-1 text-danger"></i> {props.t('Logout')}
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default withTranslation()(ProfileMenu);
